import { useQuery } from '@tanstack/react-query';
import { queryKeys, missionControlService } from '@v2/services';
import type { MissionControlPlugin } from '@v2/types';

export interface UsePluginsParams {
  pimsFilter?: string;
  includeInactivePlugins?: boolean;
}

interface UsePluginsResult {
  plugins: MissionControlPlugin[];
  loading: boolean;
  error: string | null;
  refetch: () => Promise<void>;
}

export const usePlugins = (params?: UsePluginsParams): UsePluginsResult => {
  const pimsFilter = params?.pimsFilter ?? '';
  const includeInactivePlugins = params?.includeInactivePlugins ?? false;

  const query = useQuery({
    queryKey: queryKeys.missionControl.plugins.lists({
      pimsFilter: pimsFilter || undefined,
      includeInactive: includeInactivePlugins || undefined,
    }),
    queryFn: () =>
      missionControlService.getPlugins({
        pimsFilter: pimsFilter || undefined,
        includeInactivePlugins: includeInactivePlugins || undefined,
      }),
  });

  return {
    plugins: query.data ?? [],
    loading: query.isLoading,
    error: query.error instanceof Error ? query.error.message : null,
    refetch: async () => {
      await query.refetch();
    },
  };
};

export default usePlugins;
